import styles from "../../../styles/Components/new-dashboard/AccountSummary.module.css";
import { MdPersonAddAlt1 } from "react-icons/md";
import { Skeleton } from "antd";
import { formatAmount } from "../../../utility/helper";
import WithdrawButton from "../../pricing-plan/referrals/WithdrawButton";
import DashboardContentBox from "../DashboardContentBox";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import InviteFriendsModal from "../../mini-app/mini-pricing/InviteFriendsModal";
import { useNavigate } from "react-router-dom";
import GiftIcon from "../../../ui/icons/GiftIcon";

function ReferralEarnings() {
  const {
    pricingPlan: { referralRewardsLoading, referralData },
  } = useSelector((state) => state);

  const [showInvitationModal, setShowInvitationModal] = useState(false);

  const navigate = useNavigate();

  const totalMoney = referralData?.total_cashable_credit;
  const totalCredit = referralData?.total_credit_reward;

  return (
    <DashboardContentBox
      className={styles.box}
      onClick={() => navigate("/pricing-billing/referrals")}
    >
      <span
        className={styles.inviteBtn}
        onClick={(e) => {
          e.stopPropagation();
          setShowInvitationModal(true);
        }}
      >
        <MdPersonAddAlt1 size={16} />
      </span>

      <span className={styles.boxIcon}>
        {/*<BsGift />*/}
        <GiftIcon />
      </span>
      <h5>Refer & Earn</h5>
      {referralRewardsLoading ? (
        <Skeleton.Input active />
      ) : (
        <div className={styles.infoList}>
          <span className={styles.info} style={{ flexDirection: "row" }}>
            Earned: {totalCredit && `$${formatAmount(totalMoney)}`}
            <WithdrawButton className={styles.withdrawBtn} />
          </span>
          {/*<span className={styles.info}>*/}
          {/*  Earned Credit: {totalCredit && `$${formatAmount(totalCredit)}`}*/}
          {/*</span>*/}
        </div>
      )}

      <span
        className={styles.tipMsg}
        // style={{ marginBottom: "-.5rem" }}
      >
        Get up to 40% cash!
      </span>

      {showInvitationModal && (
        <div onClick={(e) => e.stopPropagation()}>
          <InviteFriendsModal
            show={showInvitationModal}
            setShow={setShowInvitationModal}
          />
        </div>
      )}
    </DashboardContentBox>
  );
}

export default ReferralEarnings;
